import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getNonStructuredSectionsAction } from '../actions';

const {
  useLoader: useNonStructuredSectionsLoader,
  LoaderProvider,
} = createLoaderImp({
  action: getNonStructuredSectionsAction,
});

function NonStructuredSectionsLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export { NonStructuredSectionsLoader, useNonStructuredSectionsLoader };
